import React from 'react';
import i18next from 'i18next';

import type { DetailsPageProps, ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import ActivitiesView from './view/ActivitiesView';
import ActivitiesDetails from './details/ActivitiesDetails';

import buttons from './ActivitiesButtons';
import events from './ActivitiesEvents';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));
const DetailsPage = lazyRetry<DetailsPageProps>(() => import('app/main/components/page-layouts/details/DetailsPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ isModuleDisabled }) => isModuleDisabled('activities'),
	routes: [
		{
			path: 'activities/add/:tabId?',
			auth: ({ authorizer }) => authorizer.can('create', 'activities'),
			element: (
				<DetailsPage
					key="activities/add"
					module="activities"
					tabs={ActivitiesDetails}
					buttons={buttons.details}
					events={events}
					isAdd
				/>
			)
		},
		{
			path: 'activities/details/:id/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'activities'),
			element: (
				<DetailsPage
					key="activities/details"
					module="activities"
					tabs={ActivitiesDetails}
					buttons={buttons.details}
					events={events}
				/>
			)
		},
		{
			path: 'activities/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'activities'),
			element: (
				<ViewPage
					key="activities/view"
					module="activities"
					content={{ type: 'tabs', tabs: ActivitiesView }}
					buttons={buttons.view}
				/>
			)
		}
	]
};

export default routes;
